// Components
import InternalContainer from '../../Components/InternalContainer';
import CardJobs from '../../Components/CardJobs';
import JobDetail from '../../Components/JobDetail';
import { LoadingSkeleton } from '../../Components/LoadingSkeleton';
import { SkeletonTypes } from '../../Components/LoadingSkeleton/types';
// Redux
import { useDispatch, useSelector } from 'react-redux';
// Slices
import {
	setJobs,
	setIsLoadingJobs,
	setIsLoadingMoreJobs,
	searchNewData,
	setMoreDataAvailable,
	setPageJobs,
	setQueryJobsFetched,
	setRemoteJob,
	setNextPage,
} from '../../app/features/jobsSlice';
// Services
import { getJobs, normalizeJobsResponse } from '../../services/getJobs';
// Styles
import './JobsPage.css';
// Translate
import { useTranslation } from 'react-i18next';

const JobsPage = () => {
	const dispatch = useDispatch();
	const {
		jobs,
		queryJobsFetched,
		isLoadingJobs,
		isLoadingMoreJobs,
		moreDataAvailable,
		pageJobs,
		remoteJob,
		jobFetched,
		next_page,
	} = useSelector((state) => state.jobs);
	const { t } = useTranslation();
	const { institutionCode, languageInstitution } = useSelector(
		(state) => state.institution,
	);

	if (isLoadingJobs) {
		return (
			<main className='jobs jobsLoading'>
				<InternalContainer>
					<div className='jobsSkeletonContainer'>
						<div className='jobsSkeletonList'>
							{Array.from({ length: 6 }).map((_, i) => (
								<div key={i} className='jobsCardSkeleton'>
									<div className='jobsCardSkeletonHeader'>
										<span className='skeleton-box jobsCardSkeletonThumb' />
										<div className='jobsCardSkeletonHeaderText'>
											<span className='skeleton-box jobsCardSkeletonTitle' />
											<span className='skeleton-box jobsCardSkeletonCompany' />
										</div>
									</div>
									<div className='jobsCardSkeletonBody'>
										<span className='skeleton-box jobsCardSkeletonLine jobsCardSkeletonLineLong' />
										<span className='skeleton-box jobsCardSkeletonLine jobsCardSkeletonLineLong' />
										<span className='skeleton-box jobsCardSkeletonLine jobsCardSkeletonLineMedium' />
									</div>
									<div className='jobsCardSkeletonMeta'>
										<span className='skeleton-box jobsCardSkeletonPillSmall' />
										<span className='skeleton-box jobsCardSkeletonDate' />
									</div>
									<span className='skeleton-box jobsCardSkeletonShowMore' />
								</div>
							))}
						</div>
						<div className='jobsSkeletonDetail'>
							<div className='jobsSkeletonDetailHeader'>
								<span className='skeleton-box jobsSkeletonLine jobsSkeletonLineShort' />
								<div className='jobsSkeletonCompanyWrap'>
									<span className='skeleton-box jobsSkeletonAvatar' />
									<div className='jobsSkeletonCompanyText'>
										<span className='skeleton-box jobsSkeletonLine jobsSkeletonLineTitle' />
										<span className='skeleton-box jobsSkeletonLine jobsSkeletonLineMedium' />
									</div>
								</div>
								<div className='jobsSkeletonApply'>
									<span className='skeleton-box jobsSkeletonLine jobsSkeletonLineMedium' />
									<div className='jobsSkeletonApplyButtons'>
										<span className='skeleton-box jobsSkeletonPill' />
										<span className='skeleton-box jobsSkeletonPill' />
										<span className='skeleton-box jobsSkeletonPill' />
									</div>
								</div>
							</div>
							<div className='jobsSkeletonDetailBody'>
								{Array.from({ length: 12 }).map((_, i) => (
									<span
										key={i}
										className={`skeleton-box jobsSkeletonLine ${
											i % 3 === 0
												? 'jobsSkeletonLineLong'
												: 'jobsSkeletonLineMedium'
										}`}
									/>
								))}
							</div>
						</div>
					</div>
				</InternalContainer>
			</main>
		);
	}

	const HandleGetJobs = (query, page = 1, only_remote = 0, next_page = '') => {
		if (query?.length > 0) {
			if (page === 1) {
				dispatch(setIsLoadingJobs(true));
				dispatch(searchNewData());
				dispatch(setRemoteJob(0));
			} else {
				dispatch(setIsLoadingMoreJobs(true));
			}
			getJobs(query, page, only_remote, institutionCode, next_page)
				.then((response) => {
					if (response.status === 200) {
						const jobsResponse = normalizeJobsResponse(response);
						dispatch(setNextPage(jobsResponse.next_page));
						dispatch(setJobs(jobsResponse.data));
						dispatch(setQueryJobsFetched(query));
						dispatch(setPageJobs(page));
						dispatch(setMoreDataAvailable(jobsResponse.data.length > 0));
						dispatch(setIsLoadingJobs(false));
						dispatch(setIsLoadingMoreJobs(false));
					} else {
						console.error(`Request error. HTTP status: ${response.status}`);
						dispatch(setIsLoadingJobs(false));
						dispatch(setIsLoadingMoreJobs(false));
					}
				})
				.catch((error) => {
					console.error('Request error:', error);
					dispatch(setIsLoadingJobs(false));
					dispatch(setIsLoadingMoreJobs(false));
				});
		}
	};

	const HandleApplyFilter = (remote) => {
		dispatch(setRemoteJob(remote));
		dispatch(setIsLoadingJobs(true));
		dispatch(searchNewData());
		getJobs(queryJobsFetched, 1, remote, institutionCode)
			.then((response) => {
				if (response.status === 200) {
					const jobsResponse = normalizeJobsResponse(response);
					dispatch(setJobs(jobsResponse.data));
					dispatch(setPageJobs(1));
					dispatch(setNextPage(jobsResponse.next_page));
					dispatch(setMoreDataAvailable(jobsResponse.data.length > 0));
					dispatch(setIsLoadingJobs(false));
				} else {
					console.error(`Request error. HTTP status: ${response.status}`);
					dispatch(setIsLoadingJobs(false));
				}
			})
			.catch((error) => {
				console.error('Request error:', error);
				dispatch(setIsLoadingJobs(false));
			});
	};

	return (
		<main className='jobs'>
			{jobs?.length > 0 ? (
				<>
					<div className='jobsSummary'>
						<InternalContainer className='no-filters filters'>
							<p>{t('Filter')}:</p>
							<select
								value={remoteJob}
								className='categoryBarJob'
								onChange={(e) => {
									HandleApplyFilter(e.target.value);
								}}
							>
								<option disabled>{t('What are you searching?')}</option>
								<option value={0}>{t('In Person')}</option>
								<option value={1}>{t('Remote')}</option>
							</select>
						</InternalContainer>
					</div>
					<InternalContainer className='no-filters'>
						<div className='jobsContainer'>
							<section
								className={
									Object.keys(jobFetched)?.length === 0
										? 'jobsList'
										: 'jobsList deactivate'
								}
							>
								<div className='scroll-container'>
									<div className='scroll-content jobsList_results'>
										{jobs?.map((job, i) => {
											return (
												<CardJobs
													key={i}
													id={job.job_id}
													img={job.thumbnail}
													title={job.title}
													company={job.company_name}
													description={(job.description || '').substring(
														0,
														100,
													)}
													salary={job.detected_extensions?.salary}
													date={job.detected_extensions?.posted_at}
													schedule_type={job.detected_extensions?.schedule_type}
													job={job}
													work_from_home={
														job.detected_extensions?.work_from_home
													}
													language={languageInstitution}
												/>
											);
										})}

										{isLoadingMoreJobs &&
											Array.from({ length: 3 }).map((card, i) => (
												<LoadingSkeleton
													key={i + 999}
													type={SkeletonTypes.LIBRARY_CARD}
												/>
											))}
										{moreDataAvailable && !isLoadingMoreJobs && (
											<p
												className='showMoreJobs !text-xl'
												role='button'
												onClick={() =>
													HandleGetJobs(
														queryJobsFetched,
														pageJobs + 1,
														remoteJob,
														next_page,
													)
												}
											>
												{t('Show more jobs')}
											</p>
										)}
									</div>
								</div>
							</section>
							<JobDetail language={languageInstitution} />
						</div>
					</InternalContainer>
				</>
			) : isLoadingJobs === false &&
			  jobs.length === 0 &&
			  queryJobsFetched.length === 0 ? (
				<div className='noDataContainerJobs'>
					<InternalContainer className='no-data'>
						<p>{t('Please enter a search term')}</p>
					</InternalContainer>
				</div>
			) : (
				<div className='noDataContainerJobs'>
					<InternalContainer className='no-data'>
						<p>{t('No jobs found')}</p>
					</InternalContainer>
				</div>
			)}
		</main>
	);
};

export default JobsPage;
